export const taboolaScript = `
window._tfa = window._tfa || [];
window._tfa.push({notify: "event", name: "page_view", id: 1509742});
!(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = 1;
    t.defer = true;
    t.src = a;
    t.id = x;
    t.onload = execCactusEvents('taboola');
    f.parentNode.insertBefore(t, f);
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  "//cdn.taboola.com/libtrc/unip/1509742/tfa.js",
  "tb_tfa_script"
);
`;
